import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_8 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_customers_export_modal"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Export ")
const _hoisted_11 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_customer"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Add Customer ")
const _hoisted_14 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_15 = { class: "fw-bolder me-5" }
const _hoisted_16 = { class: "me-2" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Selected ")
const _hoisted_18 = /*#__PURE__*/_createVNode("div", {
  class: "d-flex justify-content-end align-items-center d-none",
  "data-kt-customer-table-toolbar": "selected"
}, [
  /*#__PURE__*/_createVNode("div", { class: "fw-bolder me-5" }, [
    /*#__PURE__*/_createVNode("span", {
      class: "me-2",
      "data-kt-customer-table-select": "selected_count"
    }),
    /*#__PURE__*/_createTextVNode("Selected ")
  ]),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-kt-customer-table-select": "delete_selected"
  }, " Delete Selected ")
], -1)
const _hoisted_19 = { class: "card-body pt-0" }
const _hoisted_20 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_21 = {
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_22 = {
  href: "#",
  class: "btn btn-sm btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Actions ")
const _hoisted_24 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_25 = {
  class: "\n              menu\n              menu-sub\n              menu-sub-dropdown\n              menu-column\n              menu-rounded\n              menu-gray-600\n              menu-state-bg-light-primary\n              fw-bold\n              fs-7\n              w-125px\n              py-4\n            ",
  "data-kt-menu": "true"
}
const _hoisted_26 = { class: "menu-item px-3" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_28 = { class: "menu-item px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ExportCustomerModal = _resolveComponent("ExportCustomerModal")!
  const _component_AddCustomerModal = _resolveComponent("AddCustomerModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Customers"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          (_ctx.checkedCustomers.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("button", _hoisted_8, [
                  _createVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr078.svg" })
                  ]),
                  _hoisted_10
                ]),
                _createVNode("button", _hoisted_11, [
                  _createVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
                  ]),
                  _hoisted_13
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.checkedCustomers.length), 1),
                  _hoisted_17
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteFewCustomers()))
                }, " Delete Selected ")
              ])),
          _hoisted_18
        ])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.customers,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true
        }, {
          "cell-checkbox": _withCtx(({ row: customer }) => [
            _createVNode("div", _hoisted_20, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: customer.id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkedCustomers = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.checkedCustomers]
              ])
            ])
          ]),
          "cell-name": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.name), 1)
          ]),
          "cell-email": _withCtx(({ row: customer }) => [
            _createVNode("a", _hoisted_21, _toDisplayString(customer.email), 1)
          ]),
          "cell-company": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.company), 1)
          ]),
          "cell-paymentMethod": _withCtx(({ row: customer }) => [
            _createVNode("img", {
              src: customer.payment.icon,
              class: "w-35px me-3",
              alt: ""
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(customer.payment.ccnumber), 1)
          ]),
          "cell-date": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.date), 1)
          ]),
          "cell-actions": _withCtx(({ row: customer }) => [
            _createVNode("a", _hoisted_22, [
              _hoisted_23,
              _createVNode("span", _hoisted_24, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
              ])
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_router_link, {
                  to: "/apps/customers/customer-details",
                  class: "menu-link px-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("a", {
                  onClick: ($event: any) => (_ctx.deleteCustomer(customer.id)),
                  class: "menu-link px-3"
                }, "Delete", 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["table-data", "table-header"])
      ])
    ]),
    _createVNode(_component_ExportCustomerModal),
    _createVNode(_component_AddCustomerModal)
  ], 64))
}